<template>
  <GmapMap
    :center="position"
    :zoom="17"
    map-type-id="terrain">

    <GmapMarker
      :position="position"
    />
  </GmapMap>
</template>

<script>
export default {
  created: function () {
    this.$store.dispatch('gps/setPosition')
  },

  computed: {
    position: function () {
      return this.$store.getters['gps/position']
    }
  }
}
</script>
